/**
 * Store for the current place ID when user is authenticated.
 * AuthContext sets this when loading user profile; getCurrentPlaceId() reads it.
 */
let authPlaceId: string | null = null

export function setAuthPlaceId(placeId: string | null): void {
  authPlaceId = placeId
}

export function getAuthPlaceId(): string | null {
  return authPlaceId
}
